exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * @prettier\n */\n@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.hideOptionsOnMobile___1eyyo .toggle-list {\n  display: inline-block;\n}\n@media (max-width: 767px) {\n  .hideOptionsOnMobile___1eyyo .toggle-list {\n    display: none;\n  }\n}\n.hideOptionsOnMobile___1eyyo .detail-box img {\n  display: none;\n}\n.box___1dDK8 .toggle-list__item {\n  display: inline-block;\n}\n.imageTag___1-HYT {\n  background-color: #ebf1f9 !important;\n  border: none !important;\n  border-radius: 4px;\n  color: #276588 !important;\n  font-weight: 700;\n  margin: 8px 0;\n  padding: 3px 6px;\n}\n.imageTagBox___3ncnS {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"hideOptionsOnMobile": "hideOptionsOnMobile___1eyyo",
	"box": "box___1dDK8",
	"imageTag": "imageTag___1-HYT",
	"imageTagBox": "imageTagBox___3ncnS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/common/Letterpress/LetterpressPaperOption/styles.module.less
// module id = 1787
// module chunks = 68